/**
 * Mobile PWA — auth helpers.
 *
 * 唯一入口是扫桌面 QR：/pair?code=XXX → handoff → server mint 24h mobile JWT，
 * 存进 localStorage。没有 username/password 登录。
 */

export const TOKEN_KEY = 'cortex-m-token'

export function getToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY)
  } catch {
    return null
  }
}

export function setToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token)
  } catch {}
}

export function clearToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY)
  } catch {}
}

export function isAuthenticated(): boolean {
  return getToken() !== null
}
